import React, { useMemo } from 'react';
import classnames from 'classnames';
import UberLogoSvg from '../../assets/svg/logos/uber.svg';
import SpotifyLogoSvg from '../../assets/svg/logos/spotify.svg';
import AirbnbLogoSvg from '../../assets/svg/logos/airbnb.svg';
import YelpLogoSvg from '../../assets/svg/logos/yelp.svg';
import GlassdoorSvg from '../../assets/svg/logos/glassdoor.svg';
import InstacartSvg from '../../assets/svg/logos/instacart.svg';
import SendGridLink from '../SendGridLink';
import { StyledLogoBar, StyledLogos, StyledLogo } from './styles';

const TrustLogoBar = ({ title, isHome, isMaintenance }) => {
  const message = useMemo(() => {
    if (title) {
      return (
        <p
          className="m-bottom-3 is-size-14 is-medium"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      );
    }

    if (isHome) {
      return (
        <p style={{display: "none"}}>
        </p>
      );
    }

    return (
      <p className="m-bottom-3 is-size-20 is-medium">
        Over{' '}
        <SendGridLink to="/customers/" className="is-bold">
          80,000 paying customers
        </SendGridLink>{' '}
        trust Twilio SendGrid to deliver:
      </p>
    );
  }, [title, isHome, isMaintenance]);

  return (
    <StyledLogoBar
      className={classnames('row', 'text-center', 'trust-logo-bar', {
        maintenance: isMaintenance,
      })}
    >
      {message}
      <StyledLogos className="styled-logos">
        <StyledLogo logo="uber">
          <UberLogoSvg />
        </StyledLogo>
        <StyledLogo logo="spotify">
          <SpotifyLogoSvg />
        </StyledLogo>
        <StyledLogo logo="airbnb">
          <AirbnbLogoSvg />
        </StyledLogo>
        <StyledLogo logo="yelp">
          <YelpLogoSvg />
        </StyledLogo>
        <StyledLogo logo="glassdoor">
          <GlassdoorSvg />
        </StyledLogo>
        <StyledLogo logo="instacart">
          <InstacartSvg />
        </StyledLogo>
      </StyledLogos>
    </StyledLogoBar>
  );
};

export default TrustLogoBar;
